import React, { useMemo } from 'react';

import mobileGameDefaultIcon from '@/pages/opinion/assets/svg/mobile-game-default.svg';
import EChartCommon from '@/pages/opinion/components/EChartCommon';
import {
  echartTooltipTime,
  formatChartParamsDate,
} from '@/pages/opinion/components/ChartCommon/formatter';
import { getIconInfo } from './utils';
import { reviewsFormat, scoreFormat } from '@/pages/opinion/utils/value';
import { useIntl } from 'umi';
import { NO_DATE } from '@/pages/opinion/constants';

interface barFace {
  // chart的高度
  height?: number;
  platform: string;
  commonParams: object;
  dataList: any[];
  loading: boolean;
  leftTitle?: string;
  rightTitle?: string;
}
const PcConsoleBarChart = ({
  height,
  platform,
  dataList,
  commonParams,
  loading,
  leftTitle,
  rightTitle,
}: barFace) => {
  const { formatMessage } = useIntl();

  /**
   * 设置ehcarts 数据
   */
  const getEchartsData = () => {
    if (dataList?.length > 0) {
      const score: any = [];
      const reviews: any = [];
      const games: any = [];
      let xAxisLabel: any = {};
      let xRich: any = {};
      let gameInfo: any = {};
      dataList?.map((item) => {
        score.push(item?.user_score?.Score);
        reviews.push(item?.user_score?.Review);

        xAxisLabel[item?.edition_unified_id] = item?.name;
        xRich[item?.edition_unified_id] = {
          backgroundColor: {
            image: item?.cover || mobileGameDefaultIcon,
          },
          align: 'center',
          width: 25,
          height: 25,
        };
        gameInfo[item?.edition_unified_id] = {
          name: item.name,
          cover: item?.cover || mobileGameDefaultIcon,
        };
        games.push(item?.edition_unified_id);
      });
      return {
        tooltip: {
          formatter: (params: any) => {
            const timeText = echartTooltipTime(commonParams);
            const key = params?.[0]?.axisValue;
            const { name, cover } = gameInfo[key];

            return formatChartParamsDate({
              title: timeText,
              params,
              beforeSort: false,
              valueFormat: (value, element) => {
                return element.seriesName === 'Lifetime User Score'
                  ? scoreFormat(value)
                  : reviewsFormat(value);
              },
              listTitleFunc: (element) => {
                return formatMessage({
                  id: element.seriesName || NO_DATE.EMPTY,
                });
              },
              tablesConfigFunc: (records: Array<any>) => {
                return [
                  {
                    showHeader: true,
                    records,
                    columns: [
                      {
                        key: 'text',
                        header: getIconInfo(cover, name),
                      },
                      {
                        key: 'value',
                        align: 'right',
                        weight: 'bold',
                        header: '',
                      },
                    ],
                  },
                ];
              },
            });
          },
        },
        xAxis: [
          {
            boundaryGap: true,
            data: games,
            axisTick: {
              interval: 0,
            },
            axisLine: {
              lineStyle: {
                color: 'rgba(0, 0, 0, 0.25)',
              },
            },
            axisLabel: {
              interval: 0,
              formatter: function (value: any) {
                return '{' + value + '| }' + '\n\n' + xAxisLabel[value];
              },
              width: 60,
              overflow: 'truncate',
              ellipsis: '...',
              rich: xRich,
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
          },
          {
            type: 'value',
          },
        ],
        series: [
          {
            name: 'Lifetime User Score',
            type: 'line',
            yAxisIndex: 1,
            lineStyle: {
              color: '#5086F3',
            },
            data: score,
          },
          {
            name: 'Lifetime Reviews-1',
            type: 'bar',
            stack: '1',
            yAxisIndex: 0,
            data: reviews,
            itemStyle: {
              color: '#4FCB87',
            },
            barMaxWidth: '70px',
          },
        ],
        legend: {
          show: false,
        },
        grid: {
          right: 0,
          top: 6,
          bottom: 0,
          containLabel: true,
        },
      };
    }
    return [];
  };

  const options = useMemo(() => {
    return getEchartsData();
  }, [platform, dataList, formatMessage]);

  return (
    <EChartCommon
      empty={dataList.length === 0}
      height={height}
      options={options}
      leftTitle={leftTitle}
      rightTitle={rightTitle}
      optionsProps={{ type: 'bar' }}
      loading={loading}
    ></EChartCommon>
  );
};

export default React.memo(PcConsoleBarChart);
